import React from "react";
import CtaButton from "./CtaButton/CtaButton";
import Team from "./Team";
import styles from "./ThirdBox.module.css";
import mohammad from "./../images/mohammad.jpg";
import mahtab from "./../images/mahtab.jpg"
import mahdi from "./../images/mahdi4.jpg"
const ThirdBox = () => {
  return (
    <div className="eachpage third">
      <div className={styles.teamtitle}>تیم ما
      <div className={styles.teamdesc}>ما اینجاییم تا آنچه که لایق شماست برای شما فراهم آوریم</div>
      </div>
      <div className={styles.teambox}> 
        <Team name="محمد رضا حسینی نسب" image={mohammad} instagram="mohammadh0seiny">مدیر پروژه | برنامه نویس | بنیان گذار</Team>
        <Team name="مهتاب عزیزی" image={mahtab} instagram="mahtab__azizi">متخصص رابط کاربری UI/UX</Team>
        <Team name="مهدی سید معلمی" image={mahdi} instagram="mahdi_moallemy">برنامه نویس وب</Team>
      </div>
      
    </div>
  );
};

export default ThirdBox;
